import { DATETIME_NO_DOT_FORMAT } from 'common/constants'
import { OperationLog } from 'common/models'
import moment from 'moment'
import React from 'react'

import { useTargetName } from '../hooks/use-target-name'

type HeaderTitleProps = {
  logItem: OperationLog
}

export const HeaderTitle = ({ logItem }: HeaderTitleProps) => {
  const date = moment(logItem.createdAt).format(DATETIME_NO_DOT_FORMAT)
  const target = useTargetName(logItem)

  return (
    <div className="breadcrumb-title-text">
      <span style={{ marginRight: 20 }}>{date}</span>
      <span>{target}</span>
    </div>
  )
}
